import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from "@angular/core";
import * as moment from "moment";

import { TeamsService } from "../teams.service";
import { Equipe } from "../models/equipe";
import { Router, ActivatedRoute } from "@angular/router";

import { environment } from "../../../environments/environment";
import { LoaderService } from "src/app/loader/loader.service";
import { User } from "src/app/users/models/user";
import { UsersService } from "src/app/users/users.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { EquipeModel } from "../models/equipe-model";

@Component({
  selector: "app-teams-edit",
  templateUrl: "./teams-edit.component.html",
  styleUrls: ["./teams-edit.component.scss"],
})
export class TeamsEditComponent implements OnInit {
  env;
  team: EquipeModel;
  teamData: Equipe;
  users: User[];
  supervisors: User[];
  members: User[];

  timeoutIDError;
  timeoutIDWarn;

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};
  selectedCompanies = [];
  othersCompanies = [];

  teamType: string;

  @ViewChild("alertError", { read: ElementRef, static: false })
  alertError: ElementRef;

  @ViewChild("alertWarn", { read: ElementRef, static: false })
  alertWarn: ElementRef;

  constructor(
    private teamsService: TeamsService,
    private usersService: UsersService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    this.env = environment;
  }

  async ngOnInit() {
    this.setCompaniesDropdown();
    await this.getTeam(this.route.snapshot.paramMap.get("id"));
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, "innerHTML", msg);
    this.renderer.setProperty(this.alertError.nativeElement, "hidden", false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, "hidden", true);
    }, 8000);
  }

  addWarnAlert(msg: string) {
    clearTimeout(this.timeoutIDWarn);

    this.renderer.setProperty(this.alertWarn.nativeElement, "innerHTML", msg);
    this.renderer.setProperty(this.alertWarn.nativeElement, "hidden", false);

    this.timeoutIDWarn = setTimeout(_ => {
      this.renderer.setProperty(this.alertWarn.nativeElement, "hidden", true);
    }, 8000);
  }

  onSubmit() {
    if (this.teamHaveCompaniesPermissions(this.selectedCompanies)) {
      this.handleTeamSubmitData();
      this.updateTeam(this.team._id, this.team);
    } else {
      this.addErrorAlert("Usuários não tem permissões em todas as empresas selecionadas");
    }
  }

  private handleTeamSubmitData() {
    this.team.membros = this.team.membros.filter(member => {
      return !member.deleted;
    });

    this.team.membros = this.team.membros.map(member => {
      const { _id } = member;
      return { _id };
    });

    this.team.empresas = this.selectedCompanies.map(company => {
      const companyData = this.env.user.empresas.find(companyValue => companyValue.cnpj === company.cnpj);
      return { _id: companyData._id };
    });

    if (this.othersCompanies.length > 0) {
      this.team.empresas.push(this.othersCompanies);
    }

    this.team.empresas.sort();
  }

  async updateTeam(id: string, team: EquipeModel) {
    const loader = await this.loaderService.notifica({
      title: "Salvando equipe...",
      date: moment().toISOString(),
      type: "loading",
    });

    const updTeam = await this.teamsService.updateTeam(id, team).toPromise();

    if ("error" in updTeam) {
      this.addErrorAlert(updTeam.error);
    } else {
      this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
    }

    loader.dismiss();
  }

  async getTeam(id: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando equipe...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.teamData = await this.teamsService.getTeam(id).toPromise();

    this.handleTeamModel(this.teamData);

    this.filterCompaniesByUserPermissions();

    loader.dismiss();
  }

  private handleTeamModel(teamData: Equipe) {
    this.team = new EquipeModel();
    this.team._id = teamData._id;
    this.team.nome = teamData.nome;
    this.team.supervisor = teamData.supervisor._id;
    this.team.gestor = teamData.gestor._id;
    this.team.deleted = teamData.deleted;
    this.team.membros = teamData.membros.map(member => {
      return { _id: member._id, email: member.email };
    });

    this.teamType = teamData.membros[0].novoPerfil.nome === "Virtus Service - APP" ? "Serviços" : "Vendas";
  }

  addNewMember() {
    const emptyMembers = this.team.membros.filter(member => {
      return member._id === "" && !member.deleted;
    }).length;

    if (emptyMembers === 0) {
      this.team.membros.push({ _id: "", email: "", deleted: false, new: true });
    } else {
      this.addWarnAlert("Preencha o nome do novo membro antes de adicionar um novo.");
    }
  }

  deleteMember(index) {
    const numberOfMembers = this.team.membros.filter(member => {
      return !member.deleted;
    }).length;

    if (numberOfMembers > 1) {
      this.team.membros[index].deleted = true;
    } else {
      this.addWarnAlert("Equipe deve ter ao menos um membro.");
    }
  }

  onChangeMember(id: string) {
    const user = this.users.filter(user => user._id === id)[0];

    if (user) {
      this.team.membros.map((member, index) => {
        if (member._id === id) {
          this.team.membros[index].email = user.email;
        }
      });
    }
  }

  private filterCompaniesByUserPermissions() {
    //-- Filter by only companies that user have permissions
    //-- Save the others to restore on moment to send to API
    this.othersCompanies = this.teamData.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return false;
        }
      }
      return true;
    });

    this.selectedCompanies = this.teamData.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return true;
        }
      }
      return false;
    });
  }

  setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;

    this.dropdownSettings = {
      singleSelection: false,
      idField: "cnpj",
      textField: "fantasia",
      selectAllText: "Selecionar Todos",
      unSelectAllText: "Deselecionar Todos",
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
    };
  }

  async onChangeCompanies(companies: any[]) {
    let allUsers: User[] = [];
    const getCompaniesUsers = companies.map(company => {
      return this.usersService.getUsers(company.cnpj).toPromise();
    });

    //-- Get all users by company
    const companiesUsers = await Promise.all([...getCompaniesUsers]);

    //-- Flat array by company to an array with all users
    companiesUsers.forEach(companyUsers => allUsers.push(...companyUsers));

    //-- Remove duplicates users
    this.users = allUsers.reduce((users, currentUser) => {
      return users.every(user => user._id !== currentUser._id) ? [...users, currentUser] : users;
    }, []);

    await this.filterUsersByProfile(this.users);
  }

  async filterUsersByProfile(users: User[]) {
    this.supervisors = users
      .filter(user => {
        if (this.teamType === "Vendas") {
          return user.novoPerfil.nome === "Supervisor";
        } else {
          return user.novoPerfil.nome === "Virtus Service - Supervisor";
        }
      })
      .sort();

    //-- Keep actual supervisor and manager of the team even if their profile is no longer allowed
    [this.teamData.supervisor, this.teamData.gestor].forEach(teamUser => {
      if (teamUser && this.supervisors.every(user => user._id !== teamUser._id)) {
        this.supervisors.push(teamUser);
      }
    });

    this.members = users.filter(user => {
      if (this.teamType === "Vendas") {
        return user.novoPerfil.nome === "Vendedor" || user.novoPerfil.nome === "Vendedor e Cobrador";
      } else {
        return user.novoPerfil.nome === "Virtus Service - APP";
      }
    });

    //-- Check if user has active team
    const asyncFilter = async arr => {
      const results = await Promise.all(arr.map(user => this.userHasNotActiveTeam(user._id)));

      return arr.filter((_v, index) => results[index]);
    };
    this.members = await asyncFilter(this.members);

    //-- add users of actual team
    this.users = [...this.users, ...this.teamData.membros].sort();
    this.members = [...this.members, ...this.teamData.membros].sort();
  }

  private async userHasNotActiveTeam(userId: string) {
    const teams = await this.teamsService.getUserTeams(userId).toPromise();
    let hasActiveTeam = false;

    if (teams.length > 0) {
      hasActiveTeam = true;
    }

    return !hasActiveTeam;
  }

  teamHaveCompaniesPermissions(companies: any[]) {
    let supervisorPermitted = false;
    let managerPermitted = false;
    let membersPermitted = false;

    const supervisor = this.users.find(user => user._id === this.team.supervisor);
    const manager = this.users.find(user => user._id === this.team.gestor);
    let members = this.team.membros.map(member => {
      return this.users.find(user => user._id === member._id && !member.deleted);
    });
    members = members.filter(member => member);

    supervisorPermitted = companies.every(company => {
      return supervisor.empresas.find(userCompany => userCompany.cnpj === company.cnpj) !== undefined;
    });

    managerPermitted = companies.every(company => {
      return manager.empresas.find(userCompany => userCompany.cnpj === company.cnpj) !== undefined;
    });

    membersPermitted = companies.every(company => {
      return members.every(member => {
        return member.empresas.find(userCompany => userCompany.cnpj === company.cnpj) !== undefined;
      });
    });

    return supervisorPermitted && managerPermitted && membersPermitted;
  }

  userIsNotSelected(id: string) {
    let userNotSelected: Boolean = true;
    const activeMembers = this.team.membros.filter(member => member.deleted === undefined || member.deleted === false);
    const member = activeMembers.find(member => member._id === id);
    if (member) {
      userNotSelected = false;
    }

    return userNotSelected;
  }

  goBack(): void {
    this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
  }
}
